export default __webpack_public_path__ + "static/media/zulayimage2.10be8392.png";